"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
/**
 * Empty "no-op" function.
 */
function noop() {
}
exports.noop = noop;
//# sourceMappingURL=noop.js.map